import {useEffect, useRef, useState} from 'react';
import {Account} from '../../accounts/types';
import {checkAccountSession} from '../services/AccountSessionService';
import {clearInvalidSession} from '../services/clearInvalidSession';
import {AccountSessionInfo} from '../types';

let checkQueue: Promise<void> = Promise.resolve();

export const useAccountSession = (account: Account) => {
    const [info, setInfo] = useState<AccountSessionInfo>({
        accountId: account.id,
        email: account.emailAddress,
        isActive: false,
        isExpired: true
    });
    const [isLoading, setIsLoading] = useState(true);
    const hasAutoCleared = useRef(false);

    // Reset flag when account identity changes
    useEffect(() => {
        hasAutoCleared.current = false;
    }, [account.id]);

    useEffect(() => {
        const checkSession = async () => {
            setIsLoading(true);
            
            checkQueue = checkQueue.then(async () => {
                const result = await checkAccountSession(account);

                // Auto-clear invalid sessions once per account load
                if (!result.isActive && !hasAutoCleared.current && account.updatedAt) {
                    hasAutoCleared.current = true;
                    console.log('LOGIN APP. AUTO-CLEARING INVALID SESSION', account.emailAddress);
                    await clearInvalidSession(account);
                }

                setInfo(result);
                setIsLoading(false);
            });
            
            await checkQueue;
        };

        checkSession();
    }, [account, account.updatedAt]);

    return {
        status: {isActive: info.isActive, isExpired: info.isExpired},
        isLoading
    };
};
